import { alpha, Theme } from '@mui/material/styles';
import type { AppThemeId } from '../../themes/themeRegistry';

export function getLoginPageBackground(theme: Theme, themeId: AppThemeId): string {
  if (themeId === 'dark') {
    return 'linear-gradient(135deg, #0a101f 0%, #111c33 45%, #1a2f52 100%)';
  }
  if (themeId === 'copa') {
    return (
      theme.palette.gradient?.primary
      ?? 'linear-gradient(135deg, #012a15 0%, #013f1e 50%, #026b34 100%)'
    );
  }
  return `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.light} 100%)`;
}

export function getLoginCardHeaderBackground(theme: Theme, themeId: AppThemeId): string {
  if (themeId === 'dark') {
    return 'linear-gradient(135deg, #0d1526 0%, #1a2f52 50%, #2563eb 100%)';
  }
  if (themeId === 'copa') {
    return (
      theme.palette.gradient?.primary
      ?? 'linear-gradient(135deg, #012a15 0%, #013f1e 50%, #026b34 100%)'
    );
  }
  return (
    theme.palette.gradient?.primary
    ?? `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`
  );
}

export function getLoginCardSx(theme: Theme, themeId: AppThemeId) {
  return {
    borderRadius: 3,
    overflow: 'hidden',
    bgcolor: 'background.paper',
    border:
      themeId === 'dark'
        ? `1px solid ${alpha('#3b82f6', 0.22)}`
        : themeId === 'copa'
          ? `1px solid ${alpha(theme.palette.primary.main, 0.15)}`
          : themeId === 'rosa'
            ? `1px solid ${alpha(theme.palette.primary.main, 0.18)}`
            : themeId === 'usa'
              ? `1px solid ${alpha(theme.palette.primary.main, 0.16)}`
              : 'none',
    boxShadow:
      themeId === 'dark'
        ? '0 24px 48px rgba(0,0,0,0.45)'
        : themeId === 'copa'
          ? '0 20px 40px rgba(1, 63, 30, 0.22)'
          : themeId === 'rosa'
            ? '0 20px 40px rgba(216, 27, 122, 0.22)'
            : themeId === 'usa'
              ? '0 20px 40px rgba(10, 49, 97, 0.22)'
              : 10,
  };
}

export function getLoginFooterTextColor(themeId: AppThemeId): string {
  if (themeId === 'copa' || themeId === 'default' || themeId === 'rosa' || themeId === 'usa') {
    return '#ffffff';
  }
  return '#e2e8f0';
}
